import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ResgatePacoteJanelaRoutingModule } from './resgate-pacote-janela-routing.module';
import { ResgatePacoteJanelaComponent } from './resgate-pacote-janela.component';
import { TableModule } from 'primeng/table';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    ResgatePacoteJanelaComponent
  ],
  imports: [
    CommonModule,
    ResgatePacoteJanelaRoutingModule,
    TableModule,
    ProgressSpinnerModule,
    MessagesModule
  ]
})
export class ResgatePacoteJanelaModule { }
